export type StatusPipeType = 'on' | 'off';